var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg:absolute left-0 flex lg:flex-col lg:top-1/2 lg:transform -translate-y-1/2 mb-5 lg:mb-0 opacity-90"},[_c('SocialTwitter'),_vm._v(" "),_c('SocialFacebook')],1)}
var staticRenderFns = []

export { render, staticRenderFns }